import {useMessages} from "i18n";
import Seo from "../seo/Seo";
import LoginPage from "../signup/LoginPage";

/** Public, pre-rendered login page. */
export function Component() {
	const {seo} = useMessages();
	return (
		<>
			<Seo
				title={seo.login.title}
				description={seo.login.description}
				path="/login"
			/>
			<LoginPage/>
		</>
	);
}
